"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScopes = void 0;
const react_1 = require("react");
const useSession_1 = require("./useSession");
const useScopes = (scopes) => {
    const session = (0, useSession_1.useSession)();
    return (0, react_1.useMemo)(() => {
        return session.data?.hasScopes?.(scopes) || false;
    }, [session.data, scopes]);
};
exports.useScopes = useScopes;
